import cx from 'classnames';
import { WEEKDAYS } from 'constants/dates';
import { Marked, Title } from 'themes/playful/components/Title/Title';

import { useBusiness } from 'hooks/business/useBusiness';

import { getFormattedBusinessHours } from 'utils/getFormattedBusinessHours';

import s from './BusinessHoursSection.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const PlayfulBusinessHoursSection = () => {
  const { address, addressLink, businessHours, showAddress } = useBusiness();

  return (
    <section className={cx(s.businessHours, s1.content)}>
      <div className={s.wrapper}>
        <Title className={s.title}>
          Hours <Marked>and</Marked> location
        </Title>
        <div className={s.content}>
          {showAddress ? (
            <a
              href={addressLink}
              className={s.address}
              target="_blank"
              rel="noopener noreferrer"
            >
              {address.split(',').join('\n')}
            </a>
          ) : null}

          <dl className={s.weekdays}>
            {WEEKDAYS.map((name) => {
              const { start, end, working } = businessHours[name.toLowerCase()];

              if (working) {
                return (
                  <div key={name} className={s.dayRow}>
                    <dt>{name}</dt>
                    <dd className={s.time}>
                      {getFormattedBusinessHours(start)} -{' '}
                      {getFormattedBusinessHours(end)}
                    </dd>
                  </div>
                );
              }
              return (
                <div key={name} className={cx(s.dayRow, s.dayClosed)}>
                  <dt>{name}</dt>
                  <dd className={s.time}>Closed</dd>
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
};
